import React from "react";
import Marquee from "react-fast-marquee";
import { useTranslation } from "react-i18next";
import { Camera } from "lucide-react";
import { ASSETS } from "../lib/constants";

/**
 * Right-to-left auto-scrolling photo gallery.
 * Uses the photos uploaded by the user (Cascante's real customers + bikes).
 */
export default function Gallery({ variant = "default" }) {
  const { t } = useTranslation();
  // Duplicate so even a small list keeps the marquee dense
  const photos = [...ASSETS.gallery, ...ASSETS.gallery];

  return (
    <section
      data-testid="gallery-section"
      className="relative overflow-hidden bg-brand-black py-16 md:py-20"
    >
      {/* glow */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -bottom-32 left-1/2 h-[400px] w-[700px] -translate-x-1/2 rounded-full bg-brand-orange/20 blur-[120px]"
      />

      <div className="relative mx-auto mb-10 max-w-7xl px-4 sm:px-6 lg:px-10">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <span className="inline-flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.25em] text-brand-orange">
              <Camera className="h-3.5 w-3.5" />
              {t("gallery.eyebrow", "Real riders · Real adventures")}
            </span>
            <h2 className="mt-2 font-display text-4xl uppercase leading-none text-white sm:text-5xl lg:text-6xl">
              {t("gallery.title", "The Cascante Gallery")}
            </h2>
          </div>
          <p className="max-w-sm text-sm text-white/70">
            {t(
              "gallery.subtitle",
              "Snapshots from our customers exploring Nicaragua on two wheels."
            )}
          </p>
        </div>
      </div>

      <Marquee
        speed={40}
        gradient
        gradientColor="#0A0A0A"
        gradientWidth={80}
        pauseOnHover
        direction={variant === "reverse" ? "right" : "left"}
      >
        {photos.map((src, i) => (
          <figure
            key={`${src}-${i}`}
            data-testid={`gallery-photo-${i}`}
            className="group relative mx-3 h-72 w-72 shrink-0 overflow-hidden border-2 border-brand-orange/30 transition hover:border-brand-orange md:h-80 md:w-80"
          >
            <img
              src={src}
              alt={`Cascante Moto rider ${i + 1}`}
              loading="lazy"
              className="h-full w-full object-cover transition duration-700 group-hover:scale-105"
            />
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 transition group-hover:opacity-100" />
            <div className="pointer-events-none absolute bottom-3 left-3 text-[10px] font-bold uppercase tracking-[0.22em] text-white opacity-0 transition group-hover:opacity-100">
              San Juan del Sur · NIC
            </div>
          </figure>
        ))}
      </Marquee>
    </section>
  );
}
